/**
 * Плашка выбора варианта импорта
 */
export const importModeValues = [
  { name: "Из файла", value: "load" },
  { name: "Вручную", value: "write" },
];
